import React from 'react';

const Notes = (props) => {
  const {heading} = props.data;
  const {notes} = props;

  return (
    <div className="nppe2-fc-feeding-guidelines-notes" id="fc-screenshot-feeding-guidelines-notes">
      <div className="row">
        <div className="col-xs-12 col-md-12 col-lg-12">
          <div className="nppe2-fc-sub-title-output">
            {heading}
          </div>
          <div className="nppe2-fc-feeding-guidelines-copy">
            {notes}
          </div>
        </div>



      </div>
    </div>
  );
}

export default Notes;
